import FormBase from "../FormBase";
import FormFieldAttachmentBase from "../FormFieldAttachmentBase";
import ValidationBase, { ValidationType } from "../ValidationBase";

export enum EAttachmentMedicoTerceiro {
    AtestadoCapacidadeFisicaCognitiva = 69,
    CarteiraVacinacaoAtualizadaTermoAnexo = 70,
    CertidaoEticaProfissional = 71,
    CertidaoQuitacao = 72,
    CopiaCarteiraConselho = 73,
    CopiaDiplomaGraduacaoMedicina = 74,
    CopiaRG = 75,
    CopiaTituloEspecialista = 76,
    CopiaResidenciaMedica = 77,
    CopiaCertificadosCursoReanimacaoTreinamentoACLS = 78,
    CopiaCertificadosCursoReanimacaoTreinamentoPALS = 79,
    CurriculoResumidoAtualizado = 80,
    Foto = 81,
    DeclaracaoConflitosAnexo = 82,
    ComprovanteVacinaCovid = 83,
    RegistroQualificacaoEspecialistaRQE = 84,
    CartaApresentacaoMedicoResponsavelPeloServico = 86,
}

export default class AttachmentForm implements FormBase {

    AtestadoCapacidadeFisicaCognitiva: FormFieldAttachmentBase;
    CarteiraVacinacaoOuTermo: FormFieldAttachmentBase;
    CertidaoEticaProfissional: FormFieldAttachmentBase;
    CertidaoQuitacao: FormFieldAttachmentBase;
    CopiaCRM: FormFieldAttachmentBase;
    CopiaDiplomaGraduacaoMedicina: FormFieldAttachmentBase;
    CopiaRG: FormFieldAttachmentBase;
    CopiaTituloEspecialista: FormFieldAttachmentBase;
    CopiaResidenciaMedica: FormFieldAttachmentBase;
    CopiaCertificadosCursoReanimacaoTreinamentoACLS: FormFieldAttachmentBase;
    CopiaCertificadosCursoReanimacaoTreinamentoPALS: FormFieldAttachmentBase;
    CurriculoResumidoAtualizado: FormFieldAttachmentBase;
    Foto: FormFieldAttachmentBase;
    DeclaracaoConflitos: FormFieldAttachmentBase;
    ComprovanteVacinaCovid: FormFieldAttachmentBase;
    RegistroQualificacaoEspecialistaRQE: FormFieldAttachmentBase;
    CartaApresentacaoMedicoResponsavelPeloServico: FormFieldAttachmentBase;


    constructor() {
        this.AtestadoCapacidadeFisicaCognitiva = new FormFieldAttachmentBase([], 2, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.AtestadoCapacidadeFisicaCognitiva);
        this.CarteiraVacinacaoOuTermo = new FormFieldAttachmentBase([], 1, [], EAttachmentMedicoTerceiro.CarteiraVacinacaoAtualizadaTermoAnexo);
        this.CertidaoEticaProfissional = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CertidaoEticaProfissional);
        this.CertidaoQuitacao = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CertidaoQuitacao);
        this.CopiaCRM = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CopiaCarteiraConselho);
        this.CopiaDiplomaGraduacaoMedicina = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CopiaDiplomaGraduacaoMedicina);
        this.CopiaRG = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CopiaRG);
        this.CopiaTituloEspecialista = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMedicoTerceiro.CopiaTituloEspecialista, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CopiaResidenciaMedica = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMedicoTerceiro.CopiaResidenciaMedica, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CopiaCertificadosCursoReanimacaoTreinamentoACLS = new FormFieldAttachmentBase([], 1, [], EAttachmentMedicoTerceiro.CopiaCertificadosCursoReanimacaoTreinamentoACLS, ((value: any) => { return this.ValidateFieldCustomTreinamentoACLSTreinamentoPALS(value) }));
        this.CopiaCertificadosCursoReanimacaoTreinamentoPALS = new FormFieldAttachmentBase([], 1, [], EAttachmentMedicoTerceiro.CopiaCertificadosCursoReanimacaoTreinamentoPALS, ((value: any) => { return this.ValidateFieldCustomTreinamentoACLSTreinamentoPALS(value) }));
        this.CurriculoResumidoAtualizado = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CurriculoResumidoAtualizado);
        this.Foto = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.Foto);
        this.DeclaracaoConflitos = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.DeclaracaoConflitosAnexo);
        this.ComprovanteVacinaCovid = new FormFieldAttachmentBase([], 1, [], EAttachmentMedicoTerceiro.ComprovanteVacinaCovid);
        this.RegistroQualificacaoEspecialistaRQE = new FormFieldAttachmentBase([], 1, [], EAttachmentMedicoTerceiro.RegistroQualificacaoEspecialistaRQE);
        this.CartaApresentacaoMedicoResponsavelPeloServico = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoTerceiro.CartaApresentacaoMedicoResponsavelPeloServico);

    }

    ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value: any): string {
        if (this.CopiaTituloEspecialista.Values.length === 0 && this.CopiaResidenciaMedica.Values.length === 0) {
            return "Por favor, insira a Cópia do Titulo de Especialista ou Residência Médica."
        } else {
            this.CopiaTituloEspecialista.Error = "";
            this.CopiaResidenciaMedica.Error = "";
            return "";
        }
    }

    ValidateFieldCustomTreinamentoACLSTreinamentoPALS(value: any): string {
        if (this.CopiaCertificadosCursoReanimacaoTreinamentoACLS.Values.length === 0 && this.CopiaCertificadosCursoReanimacaoTreinamentoPALS.Values.length === 0) {
            return "Por favor, insira a Cópia dos certificados do curso de reanimação."
        } else {
            this.CopiaCertificadosCursoReanimacaoTreinamentoACLS.Error = "";
            this.CopiaCertificadosCursoReanimacaoTreinamentoPALS.Error = "";
            return "";
        }
    }


    static NewInstance(): AttachmentForm {
        return new AttachmentForm();
    }

    CallInsertOrUpdateApi(): Promise<boolean> {
        return Promise.resolve(true);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;
        let maxLengthIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }

            if (element !== null) {

                let files = this.GetFieldByName(element).Values;

                for (let indexFile = 0; indexFile < files.length; indexFile++) {
                    const file = files[indexFile];

                    if (file.ErrorMessage !== null && file.ErrorMessage !== "") {
                        formIsValid = false;
                        maxLengthIsValid = false;
                    }
                }
            }
        }

        if (!formIsValid) {
            if (!maxLengthIsValid) {
                return "O tamanho do arquivo é maior do que o permitido, impossibilitando avançar. Favor remover e inserir arquivo do tamanho de até 3MB."
            } else {
                return "Por favor, insira os anexos obrigatórios."
            }
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldAttachmentBase {
        switch (name) {

            case "AtestadoCapacidadeFisicaCognitiva":
                return this.AtestadoCapacidadeFisicaCognitiva

            case "CarteiraVacinacaoOuTermo":
                return this.CarteiraVacinacaoOuTermo

            case "CertidaoEticaProfissional":
                return this.CertidaoEticaProfissional

            case "CertidaoQuitacao":
                return this.CertidaoQuitacao

            case "CopiaCRM":
                return this.CopiaCRM

            case "CopiaDiplomaGraduacaoMedicina":
                return this.CopiaDiplomaGraduacaoMedicina

            case "CopiaRG":
                return this.CopiaRG

            case "CopiaTituloEspecialista":
                return this.CopiaTituloEspecialista

            case "CopiaResidenciaMedica":
                return this.CopiaResidenciaMedica

            case "CurriculoResumidoAtualizado":
                return this.CurriculoResumidoAtualizado

            case "Foto":
                return this.Foto

            case "DeclaracaoConflitos":
                return this.DeclaracaoConflitos

            case "CopiaCertificadosCursoReanimacaoTreinamentoACLS":
                return this.CopiaCertificadosCursoReanimacaoTreinamentoACLS

            case "CopiaCertificadosCursoReanimacaoTreinamentoPALS":
                return this.CopiaCertificadosCursoReanimacaoTreinamentoPALS

            case "ComprovanteVacinaCovid":
                return this.ComprovanteVacinaCovid

            case "RegistroQualificacaoEspecialistaRQE":
                return this.RegistroQualificacaoEspecialistaRQE

            case "CartaApresentacaoMedicoResponsavelPeloServico":
                return this.CartaApresentacaoMedicoResponsavelPeloServico

            default:
                return new FormFieldAttachmentBase([], 0, []);
        }
    }
};
